import DimensionsSearchResults from "./DimensionsSearchResults";
export default DimensionsSearchResults;
